import { MixpanelAsyncStorage } from 'mixpanel-react-native'
import { createMMKV } from 'react-native-mmkv'

const mmkvStorage = createMMKV()

type MMKVStorageKey =
  | 'returningUser'
  | 'locale'
  | 'refreshToken'
  | 'appearance'
  | 'lastSelectedCountryCode'
  | 'deepLink'
  | 'isManualSignin'
  | 'isDevMode'

export const storage = {
  get: (key: MMKVStorageKey): string | undefined => mmkvStorage.getString(key),
  set: (key: MMKVStorageKey, value: string) => mmkvStorage.set(key, value),
  exists: (key: MMKVStorageKey) => mmkvStorage.contains(key),
  delete: (key: MMKVStorageKey) => mmkvStorage.remove(key),
}

export const mixpanelStorage: MixpanelAsyncStorage = {
  getItem: async (key: string) => mmkvStorage.getString(key) || null,
  setItem: async (key: string, value: string) => mmkvStorage.set(key, value),
  removeItem: async (key: string) => {
    mmkvStorage.remove(key)
  },
}
